<template>
    <div class="border-b border-gray-400 flex-1 w-full">
        <nav class="-mb-px flex space-x-8" aria-label="Tabs">
            <div v-for="tab in tabs"
                :key="tab.value"
            >
                <component
                    :is="tab.href ? 'a' : 'button'"
                    :type="tab.href ? 'link' : 'button'"
                    :href="tab.href"
                    :class="[
                        tab.current ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700',
                        'group inline-flex items-center border-b-4 px-1 py-3 outline-none'
                    ]"
                    :aria-current="tab.current ? 'page' : undefined"
                    @click="$emit('select', tab)"
                >
                    <i v-if="tab.icon"
                        :class="[
                            tab.icon,
                            tab.current ? 'text-blue-500' : 'text-gray-400 group-hover:text-gray-500', '-ml-0.5 mr-1.5 h-5 w-5',
                        ]"
                        aria-hidden="true"
                    />

                    <span>{{ tab.label }}</span>
                </component>
            </div>
        </nav>
    </div>
</template>

<script>
export default {
    props: {
        tabs: {},
    },
}
</script>
